import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { 
  FaUsers, 
  FaBuilding,
  FaChartLine,
  FaUpload,
  FaFileAlt,
  FaUser
} from "react-icons/fa";
import axios from "axios";
import "../../../styles/dashboard/SuperAdmin/SuperAdminHome.css";

const API_URL = process.env.REACT_APP_API_URL;
const getToken = () => sessionStorage.getItem("token") || localStorage.getItem("token");

/**
 * SubAdmin landing page with statistics and quick-access cards
 */
export default function SubAdminHome() {
  const [stats, setStats] = useState({
    organizations: 0,
    users: 0,
    reports: 0,
    loading: true
  });

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const dashboardRes = await axios.get(`${API_URL}/sub-admin/dashboard`, {
        headers: { Authorization: `Bearer ${getToken()}` }
      }).catch(() => ({ data: {} }));

      const dashboardData = dashboardRes.data || {};

      console.log('SubAdmin Stats data:', dashboardData);

      setStats({
        organizations: dashboardData.orgs || 0,
        users: dashboardData.users || 0,
        reports: dashboardData.checks || 0,
        loading: false
      });
    } catch (error) {
      console.error('Error fetching subadmin stats:', error);
      setStats(prev => ({ ...prev, loading: false }));
    }
  };

  const statCards = [
    {
      title: "Organizations",
      count: stats.organizations,
      icon: FaBuilding,
      gradient: "stat-org",
      link: "/sub-admin/organizations"
    },
    {
      title: "Total Users",
      count: stats.users,
      icon: FaUser,
      gradient: "stat-user",
      link: "/sub-admin/users"
    },
  ];

  const quickActions = [
    {
      title: "Organizations",
      description: "View and manage organization details",
      link: "/sub-admin/organizations",
      Icon: FaBuilding,
      gradient: "action-org",
    },
    {
      title: "Users",
      description: "Monitor and manage user accounts",
      link: "/sub-admin/users",
      Icon: FaUsers,
      gradient: "action-user",
    }
    ];

  return (
    <div className="sa-home">
      <header className="sa-header">
        <div className="sa-header-content">
          <h1 className="sa-header-title">Coordinate Agent Overview</h1>
          <p className="sa-header-description">
            Manage organizations, users, and view reports from this centralized dashboard.
            Monitor system activity and handle administrative tasks efficiently.
          </p>
        </div>
      </header>

      {/* Statistics Section */}
      <section className="sa-stats-section">
        <div className="sa-stats-grid">
          {statCards.map((stat, idx) => {
            const IconComponent = stat.icon;
            return (
              <Link key={stat.link} to={stat.link} className="sa-stat-card-link">
                <div className={`sa-stat-card ${stat.gradient}`}>
                  <div className="sa-stat-icon-wrapper">
                    <IconComponent className="sa-stat-icon" />
                  </div>
                  <div className="sa-stat-content">
                    <h3 className="sa-stat-title">{stat.title}</h3>
                    <p className="sa-stat-count">
                      {stats.loading ? (
                        <span className="sa-stat-loading">...</span>
                      ) : (
                        stat.count
                      )}
                    </p>
                  </div>
                  <div className="sa-stat-overlay"></div>
                </div>
              </Link>
            );
          })}
        </div>
      </section>

      {/* Quick Actions Section */}
      <section className="sa-quick-actions-section">
        <h2 className="sa-section-title">Quick Actions</h2>
        <div className="sa-quick-actions-grid">
          {quickActions.map((action, idx) => {
            const IconComponent = action.Icon;
            return (
              <Link key={action.link} to={action.link} className="sa-action-card-link">
                <div className={`sa-action-card ${action.gradient}`}>
                  <div className="sa-action-icon-wrapper">
                    <IconComponent className="sa-action-icon" />
                  </div>
                  <div className="sa-action-content">
                    <h3 className="sa-action-title">{action.title}</h3>
                    <p className="sa-action-description">{action.description}</p>
                  </div>
                  <div className="sa-action-arrow">→</div>
                </div>
              </Link>
            );
          })}
        </div>
      </section>
    </div>
  );
}

